@if (pageReady() && pixelJwtToken !== null && pixelJwtToken !== "") {
  @if (pageLabels$ | async; as pageLabels) {
    <main class="container">
      <div class="form-wrapper">
        <div class="tokenization-page" data-cy="modal-payment-onetime-pixel">
          <div class="modal-close-wrapper">
            <button
              type="button"
              class="pixel-modal-close"
              aria-label="Close payment method dialog"
              data-cy="btn-payment-pixel-close"
              (click)="closeModal()"
            >
              <span aria-hidden="true">X</span>
            </button>
          </div>
          <app-notification [pageName]="pageName"></app-notification>
          <mat-dialog-content>
            <div class="my-custom-loader" hidden>
              <svg width="76" height="32" viewBox="0 0 76 32">
                <circle cx="12" cy="16" r="8" fill="#e95524">
                  <animate attributeName="opacity" values="0.3;1;0.3" dur="1.2s" begin="0s" repeatCount="indefinite" />
                </circle>

                <circle cx="38" cy="16" r="8" fill="#e95524">
                  <animate
                    attributeName="opacity"
                    values="0.3;1;0.3"
                    dur="1.2s"
                    begin="0.2s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle cx="64" cy="16" r="8" fill="#e95524">
                  <animate
                    attributeName="opacity"
                    values="0.3;1;0.3"
                    dur="1.2s"
                    begin="0.4s"
                    repeatCount="indefinite"
                  />
                </circle>
              </svg>
            </div>
            <paymentus-base
              #paymentusBase
              [attr.authorization]="pixelJwtToken"
              loader-selector=".my-custom-loader"
              loader-aria-label="Loading payment information"
              appearance='{
          "styles": {
            ":root, :host, .pmt-theme-light": {
              "--pmt-primary-500": "#fa4600",
              "--pmt-primary-600": "#fa4600",
              "--pmt-error-text-font-size": "15px",
              "--pmt-error-text-color": "#eb0000",
              "--pmt-background-color": "#fff",
              "--pmt-font-color": "rgba(26,26,26,0.8)",
              "--pmt-border-color": "#e6e6e6",
              "--pmt-font-size": "19px",
              "--pmt-active-border-color": "#fa4600",
              "--pmt-radio-border-color": "#fa4600",
              "--pmt-radio-checked-background-color": "#fa4600",
              "--pmt-input-label-font-size": "16px",
              "--pmt-radio-background-color": "#fa4600",
              "--wa-color-focus": "rgb(66 66 66 / 50%)",
              "--pmt-card-icon-position-top": "47px",
              "--pmt-card-icon-position-right": "2px",
              "--pmt-primary-50": "#fa4600",
              "--pmt-primary-100": "#fa4600",
              "--pmt-primary-300": "#fa4600",
              "--pmt-primary-200": "#fa4600",
              "--pmt-primary-400": "#fa4600",
              "--pmt-primary-700": "#4d4d4d",
              "--pmt-primary-800": "#fa4600",
              "--pmt-primary-900": "#fa4600"
            }
          }
        }'
            >
              <tokenization-pixel
                #tokenizationPixel
                id="tokenization-pixel-one-time-payment"
                layout="dialog"
                hideSubmitButton
                payment-method-options='{
                "card":{
                    "validationRules": {
                        "zipcode": {
                        "type": "regex",
                        "value": "^[0-9]{5}(?:-[0-9]{4})?$",
                        "errorMessage": "Please provide a valid zip code",
                        "fieldName": "zipcode"
                        },
                        "number": {
                            "type": "card",
                             "cardTypes": ["visa","mastercard","american-express","discover"],
                            "errorMessage": "Please provide a valid card number",
                            "fieldName": "number"
                        },
                        "cvc":{
                          "type":"regex",
                          "value":"^[0-9]+$",
                          "fieldName":"cvc",
                          "errorMessage":"Please provide a valid security code"}
                    },
                    "maxLength": {
                      "name": 100
                    }
                },
                "ach": {
                "validationRules": {
                  "routingNumber": {
                    "value": "^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2])|80)([0-9]{7})$",
                    "fieldName": "routingNumber",
                    "type": "regex",
                    "errorMessage": "Please provide a valid routing number"
                  },
                  "accountNumber": {
                    "type": "regex",
                    "value": "^\\d{3,17}$",
                    "errorMessage": "Please provide a valid account number",
                    "fieldName": "accountNumber"
                  }
                },
                "maxLength": {
                  "name": 100
                }
              }
            }'
              ></tokenization-pixel>
            </paymentus-base>
            <!-- Buttons Wrapper -->
            <div class="buttons-wrapper">
              <!-- Cancel Button -->
              <button
                type="button"
                mat-flat-button
                class="gs-form-button-primary cancel-button"
                (click)="closeModal()"
                color="primary"
              >
                {{ pageLabels.cancelButtonText }}
              </button>
              <button
                type="button"
                mat-flat-button
                class="gs-form-button-primary"
                (click)="onSaveClick()"
                color="primary"
              >
                {{ pageLabels.saveButtonText }}
              </button>
            </div>
          </mat-dialog-content>
        </div>
      </div>
    </main>
  }
}
